module.exports = __webpack_public_path__ + "img/Capture12.635e41c0.jpg";